<template>
  <div class="feedbackPageHome">
    <zdy-nav :leftTitle="title" @back="back"></zdy-nav>
    <div class="home">
      <div class="top-nav">
          <div class="nav-box" v-for="(item, index) in tabList" :key="item.val" :class="active === item.val ? 'active-nav' : ''" @click="changePage(index)">
            {{ item.label }}
            <div class="bottom-line" v-if="active === item.val"></div>
          </div>
      </div>
      <div class="card-content" >
        <Spin v-if="showLoading" fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中，请稍后</div>
        </Spin>
        <cube-slide ref="slide" @change="changePage" @scroll="handleScrollStart" :options="sildeOptions"
        @scroll-end="handleScrollEnd" @touchend.native="handleTouchEnd" :threshold="0.3" :autoPlay="false" :loop="false" :initial-index="current" :refreshResetCurrent="false">
          <cube-slide-item v-for="items in tabList" :key="items.val">
            <!--  -->
            <cube-scroll ref="scroll" :data="cardList" :style="isIphone?'height: calc(100vh - 174px)':'height: calc(100vh - 140px)'"
              :scrollEvents="['scroll']" @pulling-down="onPullingDown" @pulling-up="onPullingUp" :options="options">
              <div v-if="cardList && cardList.length">
                <div :style="item.images && item.images.length && !item.replyList.length?'padding-bottom:6px':''" class="card" v-for="(item, index) in cardList" :key="index">
                  <div class="card-top">
                    <div class="card-title" v-if="fromType === '1'">{{ item.feedbackTypeName }}</div>
                    <div class="card-title" v-else>功能建议</div>
                    <div class="card-time">{{ validTime(item.createTimeStr) }}</div>
                    <div class="card-status" v-if="item.replyStatus === 0">待回复</div>
                    <div class="card-status card-status2" v-if="item.replyStatus === 1">已回复</div>
                  </div>
                  <div class="card-bottom">
                    <div class="content-text">{{ item.question }}</div> 
                    <!-- <Input class="input-textarea content-text" type="textarea" :readonly="true" :style="() => { console.log(this)}" v-model="item.question" :ref="current + 'question' + index"/> -->
                    <div class="img-box" :class="validClass(item.images)" v-if="item.images && item.images.length">
                      <img :src="tmpImg(url)" alt="" @click="clickImg(item, i)" v-for="(url, i) in item.images" :key="`url${i}`">
                    </div>
                    <div :style="item.images && item.images.length?'margin-top:4px':''" class="reply-box" v-for="(val, i) in item.replyList" :key="i">
                      <div class="reply-box-top">
                        <img class="reply-icon" src="@/assets/manager.svg" alt="">
                        <div class="reply-box-name">管理员回复：</div>
                        <div class="reply-time">{{ validTime(val.replyTime) }}</div>
                      </div>
                      <div class="reply-text">{{ val.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="noData" v-else>
                <img src="@/assets/noData.svg" alt="">
                暂无数据
              </div>
            </cube-scroll>
          </cube-slide-item>
        </cube-slide>
      </div>
      <div class="bottom-box" :style="isIphone?'':'padding-bottom:8px'">
        <div class="bottom-btn" v-if="fromType === '1'" @click="goFeedback">我要反馈</div>
        <div class="bottom-btn" v-else @click="goFeedback">提建议</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStore } from '@/utils/store'
export default {
  name: 'feedbackPageHome',
  data() {
    return {
      showLoading: false,
      active: 2,
      pageIndex: 1,
      cardList: [],
      initialIndex: 0,
      noMoreData: true,
      pullDownRefreshObj: {
        threshold: 90,
        stop: 40,
        txt: '刷新成功'
      },
      pullUpLoadObj: {
        threshold: 0,
        txt: {
          more: '上拉加载更多',
          noMore: '没有更多数据'
        }, // 配置上拉加载
        visible: false
      },
      title: '异常反馈',
      fromType: '1',
      selectedLabel: '',
      tabList: [
        {
          val: 2,
          label: '全部'
        },
        {
          val: 0,
          label: '待回复'
        },
        {
          val: 1,
          label: '已回复'
        }
      ],
      current: 0,
      isClickImg: true,
      scrollxNum: null,
      sildeOptions: {
         listenScroll: true,
         probeType: 3
      },
      isEndScroll: false
    };
  },
  computed: {
    options() {
      return {
        useTransition: false,
        pullUpLoad: this.pullUpLoadObj, // 上拉加载 若要关闭可直接 pullUpLoad：false
        pullDownRefresh: this.pullDownRefreshObj, // 下拉刷新
      }
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    isIphone(){
      console.log(navigator.userAgent,12312313);
      return /iphone/gi.test(navigator.userAgent)&& (screen.height >= 812)
    }
  },
  created() {
    if (getStore({ name: 'fromType' })) {
      this.fromType = getStore({ name: 'fromType' }).type
      if (this.fromType === '1') {
        this.title = '异常反馈'
      } else {
        this.title = '功能建议'
      }
    }
    this.feedbackList('refresh')
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.cardList.map((item, index) => {
    //     this.adjustTextareaHeight(this.current + 'question' + index)
    //   })
    // })
  },
  methods: {
    tmpImg(url) {
      return url.replace('/origin/',"/small/")
    },
    handleNav(num) {
      if (this.active === num) return
      this.active = num
      this.pageIndex = 1
      this.feedbackList('refresh')
    },
    // 获取列表
    async feedbackList(type) {
      if (type === 'refresh') {
        this.showLoading = true
      }
      this.noMoreData = false
      const params = {
        pageIndex: this.pageIndex,
        pageSize: 15,
        replyStatus: this.active === 2 ? null : this.active,
        userId: this.userInfo.USER_ID,
        // userId: 1,
        // userId: 1670085635141632,
        type: this.fromType
      }
      console.log(params)
      const res = await this.$store.dispatch('feedbackList', params)
      if (res.data.status === 1000) {
        console.log(res,123123);
        res.data.result.data.map(item => {
          if (item.images && item.images.length) {
            item.images = item.images.split(',')
          }
        })
        if (res.data.result.data && res.data.result.data.length < 15) {
          this.noMoreData = true
        } else {
          this.noMoreData = false
        }
        if (type === 'refresh') {
          this.cardList = res.data.result.data
          this.$nextTick(() => {
            this.cardList.map((item, index) => {
              this.adjustTextareaHeight(this.current + 'question' + index)
            })
          })
          this.showLoading = false
            // this.$refs.scroll.scrollTo(0, 0, 0)
        } else {
          this.cardList.push(...res.data.result.data)
          this.$nextTick(() => {
            this.cardList.map((item, index) => {
              this.adjustTextareaHeight(this.current + 'question' + index)
            })
          })
        }
      } else {
        this.showLoading = false
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: res.data.msg
        }).show()
      }
    },
    validClass(list) {
      if (list.length === 4) {
        return 'img-box1'
      }
    },
    validTime(time) {
      const year = time.split('年')[0]
      const month = time.split('年')[1].split('月')[0]
      const day = time.split('年')[1].split('月')[1].split('日')[0]
      const times = time.split(' ')[1]
      return `${year}年${Number(month)}月${Number(day)}日 ${times}`
    },
    changePage (current) {
      this.current = current
      this.handleNav(this.tabList[this.current].val)
      console.log('changePage',this.current)
    },
    // 查看大图
    clickImg(item, index) {
      if (this.isClickImg) {
        this.initialIndex = index
        const params = {
          $props: {
            imgs: item.images,
            initialIndex: 'initialIndex', // 响应式数据的key名
            loop: false
          },
          $events: {
            change: (i) => {
              // 必须更新 initialIndex
              this.initialIndex = i
            }
          }
        }
        this.$createImagePreview({ ...params }).show()
      }
    },
    // 下拉刷新数据
    onPullingDown() {
      this.pageIndex = 1
      this.feedbackList('refresh')
    },
    // 上拉加载更多
    onPullingUp() {
      if (!this.noMoreData) {
        this.pageIndex++
        this.feedbackList('more')
      } else {
        this.$refs.scroll[this.current].forceUpdate()
      }
    },
    // 我要反馈
    goFeedback() {
      this.$router.push({ name: 'feedbackPage' })
    },
    back() {
      this.$router.replace({name: 'homPage'});
    },
    handleScrollStart (x,y) {
      if (this.isClickImg) {
        console.log('开始滚动', x, y)
        this.isClickImg = false
        this.isEndScroll = false
      }
    },
    handleScrollEnd () {
      console.log('结束滚动')
      this.isClickImg = true
      this.isEndScroll = true
    },
    handleTouchEnd () {
      console.log('拖动脱离', this.isClickImg, this.isEndScroll)
      if (!this.isClickImg && !this.isEndScroll) {
        // this.$refs.slide.refresh()
      }
    },
    adjustTextareaHeight(name) {
      if (this.$refs[name].length) {
        this.$refs[name].map(item => {
          const input = item.$el.querySelector('textarea')
          input.style.height = 'auto'
          input.style.height = input.scrollHeight + 'px'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.feedbackPageHome {
  .home {
    margin-top: 44px;
    background-color: #F0F2F3;
    height: calc(100vh - 44px);
    overflow-y: scroll;

    .top-nav {
      display: flex;
      align-items: center;
      background-color: #FFFFFF;

      .nav-box {
        flex: 1;
        text-align: center;
        padding: 12px 0 11px 0;
        font-size: 15px;
        color: #1A1A1A;
        line-height: 21px;
        position: relative;

        .bottom-line {
          height: 3px;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          background-color: #008CFF;
        }
      }

      .active-nav {
        color: #008CFF;
      }
    }

    .card-content {
      padding: 0 12px 39px 12px;

      .card {
        padding: 12px 0 12px 12px;
        background-color: #FFFFFF;
        border-radius: 8px;
        margin-top: 8px;

        .card-top {
          position: relative;
          padding-right: 12px;
          .card-title {
            font-size: 16px;
            font-weight: bold;
            color: #1A1A1A;
            line-height: 21px;
            margin-bottom: 4px;
            width: calc(100vw - 135px);
          }

          .card-time {
            font-size: 13px;
            color: #999999;
            line-height: 18px;
          }

          .card-status {
            background: #FFA332;
            border-radius: 12px;
            padding: 3px 9px;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 17px;
            position: absolute;
            top: 0px;
            right: 12px;
          }
          .card-status2{
            background: #2FC568;
          }
        }

        .card-bottom {
          .content-text {
            padding: 4px 0 0 0;
            font-size: 14px;
            line-height: 20px;
            color: #696969;
            // line-height: 20px;
            padding-right: 12px;
            white-space: pre-wrap;
            .ivu-input{
              padding: 0;
              border: none;
              box-shadow: none;
            }
          }

          .img-box {
            width: calc(100vw - 40px);
            display: flex;
            flex-wrap: wrap;
            margin-top: 12px;

            img {
              width: 98px;
              height: 98px;
              border-radius: 4px;
              margin: 0 8px 8px 0;
              object-fit: cover;
            }
          }

          .img-box1 {
            width: 220px;
          }

          .reply-box {
            border-top: 1px solid #F2F2F2;
            padding: 9px 0 0px 0px;
            position: relative;
            margin-top: 12px;
            margin-right: 12px;
            .reply-box-top {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              .reply-icon {
                width: 24px;
                margin-right: 8px;
              }
              .reply-box-name {
                flex: 1;
                font-size: 13px;
                color: #1A1A1A;
              }
              .reply-time {
                font-size: 13px;
                color: #999999;
                line-height: 18px;
              }
            }
            .reply-text {
              padding-left: 32px;
              font-size: 14px;
              color: #6D7073;
              line-height: 20px;
              word-break: break-all;
              word-wrap: break-word;
              white-space: pre-wrap;
            }

            
          }
        }
      }

      .noData {
        margin-top: 170px;
        // transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #A6A6A6;
        line-height: 20px;
        // padding-top: 87px;
        // height: calc(100vh - 174px);
        img {
          margin-bottom: 3px;
        }
      }
      .cube-slide-dots{
        display: none;
      }
      .ivu-spin {
        height: calc(100vh - 88px);
        top: 88px;

        .demo-spin-icon-load {
          margin-bottom: 10px;
        }
      }
    }

    .bottom-box {
      background-color: #FFFFFF;
      padding: 8px 12px 42px 12px;
      position: fixed;
      bottom: 0;
      left: 0;

      .bottom-btn {
        width: calc(100vw - 24px);
        margin: 0 auto;
        background: rgba(0, 140, 255, .1);
        border-radius: 4px;
        height: 44px;
        line-height: 44px;
        font-size: 15px;
        color: #008CFF;
        text-align: center;
      }
    }
  }
}
</style>